import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import {
  saveReportData,
  resetReportData,
} from '../../../redux/actions';
import { SelectReportState } from '../Selector';

function EditorToolbar(props) {
  const { dirty, saving, error, isProcessing, saveReportData, resetReportData } = props;
  const ref = useRef(null);
  const [pinned, setPinned] = useState(false);

  useEffect(() => {
    const update = () => {
      const el = ref.current;
      if (!el) return;
      const container = el.parentElement;
      if (!container) return;
      const containerBottom = container.getBoundingClientRect().bottom;
      setPinned(containerBottom > window.innerHeight - 16);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return (
    <div
      ref={ref}
      className={`report-editor-toolbar${pinned ? ' report-editor-toolbar--fixed-bottom' : ''}`}
    >
      <div className="report-editor-toolbar__status">
        {isProcessing
          ? 'Loading saved template…'
          : error
          ? null
          : dirty
          ? <span className="report-editor-toolbar__status--dirty">Unsaved changes</span>
          : 'All changes saved'}
      </div>
      {error && (
        <div className="report-editor-toolbar__error">Save failed: {error}</div>
      )}
      <div className="report-editor-toolbar__actions">
        {/* <Button
          onClick={resetReportData}
          disabled={saving || isProcessing}
        >
          Reset to default
        </Button> */}
        <Button
          type="primary"
          onClick={() => saveReportData()}
          loading={saving}
          disabled={!dirty || isProcessing}
        >
          {saving ? 'Saving' : 'Save'}
        </Button>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  const slice = SelectReportState(state);
  return {
    dirty: slice.dirty,
    saving: slice.saving,
    error: slice.error,
    isProcessing: slice.isProcessing,
  };
};

const mapDispatchToProps = (dispatch) => ({
  saveReportData: (payload) => dispatch(saveReportData(payload)),
  resetReportData: () => dispatch(resetReportData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditorToolbar);
